/**
 * Patient Care Opportunity Routes
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard]
 */

import { lazy } from 'react';
import { RouteConfig } from '../../types';

const PatientCareOpportunity = lazy(() => import('@src/apps/PatientCareOpportunity/patientcareopportunity-connected'));

const networkManagementRouteFrameStyles: React.CSSProperties = {
  width: '60rem',
  maxWidth: '100%',
  margin: '0 auto',
  boxSizing: 'border-box',
};

const NetworkManagementRouteFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={networkManagementRouteFrameStyles}>{children}</div>
);

const PCORoute = () => (
  <NetworkManagementRouteFrame>
    <PatientCareOpportunity />
  </NetworkManagementRouteFrame>
);

export const patientCareOpportunityRoutes: RouteConfig[] = [
  {
    path: 'patient-care-opportunity',
    component: PCORoute,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Patient Care Opportunity',
      breadcrumb: 'Patient Care Opportunity',
      preload: false,
      delay: true,
    },
  },
];

